import { EmptyState } from "@design-system/EmptyState/EmptyState";
import { Loader } from "@design-system/Loader/Loader";
import { TaskCloseButton } from "./TaskBody/TaskBodyHeaderControls";
import { TaskTopBar } from "./TaskBody/TaskBodyHeader";
import styles from "./SelectedTaskContainer.module.scss";

interface TaskViewFallbackProps {
    isLoading: boolean;
    close: () => void;
}

/**
 * Stands in for an open task that can't be shown yet (still loading) or at
 * all (deleted, no access), keeping the top bar's close button.
 */
export const TaskViewFallback = ({
    isLoading,
    close,
}: TaskViewFallbackProps) => (
    <div className={styles.taskContainer}>
        <TaskTopBar end={<TaskCloseButton onClick={close} />} />
        <div className={styles.fallbackBody}>
            {isLoading ? (
                <Loader />
            ) : (
                <EmptyState
                    header="Couldn't load this task"
                    body="It may have been deleted, or you don't have access to it."
                />
            )}
        </div>
    </div>
);
